import { Component, OnInit, Inject } from '@angular/core';
import { PushNotificationService } from '@notification/push-notification.service';
import {
  MAT_DIALOG_DATA,
  MatDialog,
} from '@angular/material/dialog';
import { SelectionModel } from '@angular/cdk/collections';
import { NotificationTag } from './notifcation-tag.model';
import { SendNotificationConfirmationDialogComponent } from '@common/send-notification-confirmation-dialog/send-notification-confirmation-dialog.component';

@Component({
  selector: 'app-select-notification-dialog',
  templateUrl: './select-notification-dialog.component.html',
  styleUrls: ['./select-notification-dialog.component.scss'],
  providers: [PushNotificationService],
})
export class SelectNotificationDialogComponent implements OnInit {
  tagList: any;
  pushOption: '2' | '1' = '2';
  viewMode = 'TAGCONTAINER';
  slectedTagInfo: any;

  tagSelection = new SelectionModel<NotificationTag>(true, []);

  constructor(
    private pushnotificationService: PushNotificationService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialog: MatDialog
  ) {
    this.slectedTagInfo = data.value;
  }

  ngOnInit() {
    this.readAllTagNotifications();
  }

  public readAllTagNotifications() {
    this.pushnotificationService.readAllNotificationTags().subscribe(
      (response) => {
        this.tagList = response.data.tag;
      },
      (error) => {}
    );
  }

  public onDoneTag() {
    this.viewMode = 'CONFIRMANDSENDCONTAINER';
  }

  public onSelectTags() {
    this.tagList.forEach((tag) => this.tagSelection.select(tag));
  }

  public onClearTags() {
    this.tagSelection.clear();
  }

  public addTag() {
    this.viewMode = 'TAGCONTAINER';
  }
  public closeConfirmView() {
    this.viewMode = 'TAGCONTAINER';
  }

  public onSendNotification(tag) {
    const tagId = [];

    for (const item of tag) {
      tagId.push(item.id);
    }
    const notificationData = {
      id: this.slectedTagInfo.id,
      tags: tagId,
      sendToAllDevices: this.pushOption === '1' ? true : false,
    };
    this.dialog.closeAll();
    this.pushnotificationService.sendNotification(notificationData).subscribe(
      (response) => {
        const dialogRef = this.dialog.open(
          SendNotificationConfirmationDialogComponent,
          {
            height: '207',
            width: '486px',
            data: { value: response },
          }
        );
      },
      (error) => {}
    );
  }
}
